import React from 'react';

const P = {
  fontSize: '1.0625rem',
  lineHeight: 1.85,
  color: 'var(--gray)',
  marginBottom: '1.5rem',
  fontWeight: 300,
  maxWidth: '68ch'
};

// Secção 5 · O erro mais comum (fundo branco)
export const HerancasFiscalSection = () => (
  <section className="valuare-section" style={{ background: 'var(--cream)' }} data-testid="herancas-fiscal-section">
    <div className="valuare-section-content">
      <div style={{ maxWidth: '820px', margin: '0 auto', textAlign: 'left' }}>
        <div className="valuare-section-label">Valor Fiscal e Valor de Mercado</div>
        <h2 className="valuare-section-title">
          O VPT serve para o IMI,<br />
          <em>não para partilhar</em>
        </h2>
        <p style={P}>
          O Valor Patrimonial Tributário resulta de uma fórmula do Código do IMI, que combina um
          valor base por metro quadrado com coeficientes de afetação, localização, qualidade e
          vetustez. Reflete a data da última avaliação matricial e não observa o mercado atual.
        </p>
        <p style={{ ...P, marginBottom: 0 }}>
          Quando a partilha se liquida pelo VPT, quem recebe tornas recebe sobre um valor que não
          é o de mercado. A diferença não desaparece, muda apenas de bolso. Em imóveis com
          avaliação matricial antiga, essa diferença pode ascender a várias dezenas de milhares de
          euros.
        </p>
      </div>
    </div>
  </section>
);
